module.exports = __webpack_public_path__ + "img/1723614619250-WhatsApp Image 2024-08-14 at 13.45.26.jpeg.f186731b.webp";